import Vue from "vue";
import Router from "vue-router";
import HomeLayout from "@/layouts/HomeLayout.vue";
import SimplesLayout from "@/layouts/SimplesLayout.vue";
import PrintLayout from "@/layouts/PrintLayout.vue";
import Store from "@/store";

Vue.use(Router);
import { buildings } from "./buildings";
import { appAccounts } from "./appAccounts";
import { users } from "./users";
import { groups } from "./groups";
import { my } from "./my";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: HomeLayout,
      children: [
        {
          //ホーム画面
          path: "",
          name: "home",
          component: () => import("@/pages/Home.vue")
        },
        {
          //アラート
          path: "alert",
          name: "alert",
          component: () => import("@/pages/Alert/Home.vue")
        },
        {
          //アラート
          path: "alert-a",
          name: "alert-a",
          component: () => import("@/pages/Alert/Home_a.vue")
        },
        {
          //アラート
          path: "alert-b",
          name: "alert-b",
          component: () => import("@/pages/Alert/Home_b.vue")
        },
        {
          //操作履歴
          path: "activity",
          name: "activity",
          component: () => import("@/pages/Activity/Home.vue")
        },
        {
          // グループ操作履歴
          path: "activity/:groupId",
          name: "group-activity",
          component: () => import("@/pages/Activity/Home.vue")
        },
        {
          //アカウント
          path: "admin",
          name: "admin",
          component: () => import("@/pages/Admin.vue")
        },
        ...buildings,
        ...appAccounts,
        ...users,
        ...groups,
        ...my
      ]
    },
    {
      path: "/",
      component: PrintLayout,
      children: [
        {
          //電話カギシート
          path: "print-telkey",
          name: "print-telkey",
          component: () => import("@/pages/Print/TelKey.vue")
        },
        {
          //ファミリーキー発行
          path: "print-invitation",
          name: "print-invitation",
          component: () => import("@/pages/Print/InvitationQRcode.vue")
        },
        {
          //設置アカウントシート
          path: "print-app-account",
          name: "print-app-account",
          component: () => import("@/pages/Print/AppAccountQRcode.vue")
        }
      ]
    },
    {
      //グレー背景&フッターのみ
      path: "/",
      component: SimplesLayout,
      children: [
        {
          path: "login",
          name: "login",
          component: () => import("@/pages/Login.vue")
        },
        {
          path: "logout",
          name: "logout",
          component: () => import("@/pages/Logout.vue")
        },
        {
          // error
          path: "error",
          name: "error",
          component: () => import("@/pages/Error.vue")
        },
        {
          // 404 not found
          path: "*",
          name: "not-found",
          component: () => import("@/pages/404.vue")
        }
      ]
    }
  ]
});

router.beforeEach((to, _from, next) => {
  const publicNames = ["login"];
  if (to.name && publicNames.includes(to.name)) {
    return next();
  }

  if (Store.getters["app/login"]) {
    return next();
  }

  next({ name: "login", query: { path: to.path } });
});

export default router;
